<template>
  <div>
    <div class="border bg-light rounded-4 p-3 mb-3 text-center statistic-item-content" :style="`width: ${width};`">
      <ReadOnlyText :label="label" :value="value" labelClass="text-primary" contentClass="fs-3" />
    </div>
    <slot>

    </slot>
  </div>
</template>
<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core


// Components
import ReadOnlyText from '../common/ReadOnlyText.vue';

// Composables


// Stores


// Constants and Utils


// ===============================
// PROPS & EMITS
// ===============================
defineProps({
  label: {
    type: String,
    required: true
  },
  value: {
    type: [String, Number, null],
    required: false,
    default: null
  },
  width: {
    type: String,
    required: false,
    default: '100%'
  }
});

// ===============================
// COMPOSABLES & STORES
// ===============================


// ===============================
// REACTIVE STATE
// ===============================


// ===============================
// CONSTANTS
// ===============================


// ===============================
// COMPUTED PROPERTIES
// ===============================


// ===============================
// METHODS
// ===============================


// ===============================
// WATCHERS
// ===============================


// ===============================
// LIFECYCLE HOOKS
// ===============================


// ===============================
// EXPOSE
// ===============================


</script>

<style scoped>
.statistic-item-content {
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>
